import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

export interface ThematicBreakProps extends SharedProps {}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/thematic-break](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/thematic-break)
 * - Storybook: [ThematicBreak](https://designsystem.dn.se/?path=/docs/article-thematicbreak--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/thematic-break/thematic-break.scss'`
 */

export const ThematicBreak = ({ classNames, attributes }: ThematicBreakProps) => {
  const classes = formatClassString(['ds-thematic-break', classNames])

  return (
    <div className={classes} {...attributes}>
      <hr />
    </div>
  )
}

export default ThematicBreak
